module.exports = __webpack_public_path__ + "static/media/1.edf53da6.jpg";